import React from 'react';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryWrapper } from 'app/types';
import { useSnakeBar } from '../../useSnakeBar';
import type { UsageInvoicingEmployer } from '../../../Domain/Admin/Services';
import { adminServices } from '../../../Domain/Admin/Services';

const queryFn = async () => {
  const response = await adminServices.getUsageInvoicingEmployers();
  return response.data;
};

const QUERY_KEY = 'getUsageInvoicingEmployers';

export const useUsageInvoicingEmployersQuery: UseQueryWrapper<UsageInvoicingEmployer[], undefined, false> = ({
  options,
} = {}) => {
  const { showErrorSnakeBar } = useSnakeBar();

  const onError = React.useCallback(() => {
    showErrorSnakeBar({ method: QUERY_KEY });
  }, [showErrorSnakeBar]);

  return useQuery<UsageInvoicingEmployer[]>([QUERY_KEY], queryFn, {
    onError,
    ...(options || {}),
  });
};
